import { variationTemplate } from "../templates";

var VariationView = Backbone.View.extend({
    tagName: 'li',
    initialize: function(){
        _.bindAll( this, 'render');
        this.render();
    },
    render: function(){
        var item = variationTemplate( this.model.toJSON() );
        this.el.innerHTML = item;
    }
});
export { VariationView };